// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1eg36","disabled":"FileBtn_disabled__1wzaO","warn":"FileBtn_warn__5CSmL","fade":"FileBtn_fade__1GNf-"};